import { computed, Ref } from 'vue';
import { InitialPublicOfferItem } from '@libs/api-reference';

import { BETWEEN_END_PRE_ORDER_START_ORDER } from '../constants';

type UseBetweenEndPreOrderAndStartOrderType = {
  offer: InitialPublicOfferItem;
  hasPurchase: Ref<boolean>;
  isDoneOrder: boolean;
  hasPrice: boolean;
};

export default function useBetweenEndPreOrderAndStartOrder({
  offer,
  hasPurchase,
  isDoneOrder,
  hasPrice,
}: UseBetweenEndPreOrderAndStartOrderType) {
  const flow = computed(() => {
    if (isDoneOrder) {
      return 'flow1';
    }

    if (offer.hasPreOrder) {
      if (hasPrice) {
        if (hasPurchase.value) {
          return 'flow2';
        }

        return 'flow3';
      }

      return 'flow4';
    }

    if (offer.isAutomaticSubmit) {
      if (hasPrice) {
        if (hasPurchase.value) {
          return 'flow5';
        }

        return 'flow6';
      }

      return 'flow7';
    }

    return 'flow8';
  });

  return {
    time: offer.startDate,
    stylesConfig: BETWEEN_END_PRE_ORDER_START_ORDER[flow.value],
  };
}
